import React from 'react'
import ContactForm from '../components/ContactForm'
import Footer from '../components/Footer'


const Contact = () => {
  return (
    <div>
   <ContactForm/>
   <Footer/>
    </div>
  )
}

export default Contact